import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShieldAi: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconShieldAi"><Path fillRule="evenodd" clipRule="evenodd" d="M21 5.25391V13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13V5.25391L12 1.43555L21 5.25391ZM10.5996 10.5537L8 11.5537V12.3545L10.5996 13.3545L11.5996 15.9541H12.4004L13.4004 13.3545L16 12.3545V11.5537L13.4004 10.5537L12.4004 7.9541H11.5996L10.5996 10.5537Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShieldAi;
